/**
 * 생성된 OpenAPI(typescript-axios) 코드는 파일 다운로드 엔드포인트의
 * 반환 타입을 `string`으로 잘못 추론한다.
 * 런타임에는 호출부에서 axios `responseType: 'blob'`을 지정하므로 실제 응답은 Blob이다.
 * 이 헬퍼 한 곳에서만 캐스트를 수행해, 콜사이트에 `as unknown as Blob`이 흩어지지 않도록 한다.
 */
export const toBlobResponse = (data: unknown): Blob => data as Blob;
